import { render } from "./WalletStakeModal.vue?vue&type=template&id=3d869f7a"
import script from "./WalletStakeModal.vue?vue&type=script&lang=js"
export * from "./WalletStakeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__